// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_lg-0";
export var discountCodeInput = "_lg-1";